var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2048 2048"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Icons_Type_02_Innovation_Selected"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2048,
    height: 2048
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_Type_02_Innovation_Selected",
    clipPath: "url(#clip-Icons_Type_02_Innovation_Selected)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_Type_02_Innovation_Selected-2",
    "data-name": "Icons_Type_02_Innovation_Selected",
    transform: "translate(134.288 181.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow",
    transform: "translate(214.828 120.587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shadow_Layer"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 782.298,
    cy: 782.299,
    rx: 782.298,
    ry: 782.299,
    fill: "#eaeaea"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 296.908,
    height: 916.06,
    transform: "translate(639.418 647.524)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M507.323,1542.244a36.005,36.005,0,0,1-10.133-2.027C202.308,1415.576,11.8,1127.788,11.8,807.572,11.8,368.8,368.5,12.1,807.272,12.1s795.471,356.7,795.471,795.472c0,320.215-190.508,608-485.39,732.645a25.414,25.414,0,1,1-20.267-46.613c276.642-116.534,454.99-386.083,454.99-686.031,0-410.4-334.4-744.805-744.8-744.805s-744.8,334.4-744.8,744.805c0,299.948,178.348,569.5,454.99,686.031a24.532,24.532,0,0,1,13.173,33.44C526.577,1537.177,517.456,1542.244,507.323,1542.244Z",
    transform: "translate(-11.8 -12.1)",
    fill: "#4c4c4c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(256.656 174.084)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M986.346,200.744A553.169,553.169,0,0,0,602.29,29.489C456.37,25.436,315.515,80.156,209.115,180.477A553.17,553.17,0,0,0,37.86,564.533,558.966,558.966,0,0,0,99.674,850.3c45.6,88.161,113.494,163.148,196.588,215.842,27.36-30.4,104.374,189.495,109.441,193.548-5.067,28.374-52.694,41.547-44.587,68.907,5.067,15.2,25.333,21.28,28.374,37.494,5.067,22.293-28.374,36.48-28.374,59.787,0,25.333,39.52,32.427,49.654,55.734,4.053,9.12,3.04,20.267,9.12,28.373,5.067,6.08,13.173,9.12,20.267,11.147,57.76,17.227,119.574,16.213,180.375,13.174,37.493-2.027,77.014-6.08,107.414-26.347,31.414-21.28,49.654-64.854,30.4-97.281-11.147-18.24-33.44-37.494-23.307-55.734,5.067-9.12,16.214-14.187,24.32-20.267,14.187-11.147,22.293-30.4,18.24-48.641-3.04-18.24-17.227-33.44-35.467-38.507,21.28,6.08,49.654-67.894,55.734-83.094,16.213-40.534,41.547-76,79.04-100.321,79.041-50.667,143.894-120.588,189.495-202.668a552.717,552.717,0,0,0,69.92-268.535C1140.374,448,1086.667,306.131,986.346,200.744Zm-348.589,1010.3c3.04,21.28,30.4,37.493,25.333,58.774-4.053,17.227-28.373,25.333-31.414,42.56-1.013,10.134,5.067,19.253,7.093,29.387,5.067,20.267-7.093,40.533-23.307,52.693-26.347,19.253-64.854,21.28-93.227,3.04-28.374-17.227-43.574-52.694-37.493-85.121,4.053-24.32,19.253-48.641,11.147-71.947-7.093-20.267-29.387-31.413-41.547-49.654-16.213-23.307-10.133-59.787,13.173-77.014,41.547-29.387-22.294-59.787,7.093-93.227,12.16-14.187,36.48-11.147,48.64-31.414,15.2-24.32,7.093-56.747,3.04-83.094-19.253-92.214-44.587-183.415-77.014-271.575-10.133-27.36-16.213-64.854,9.12-78.027,39.52-19.253,66.88,53.707,109.441,55.734a156.722,156.722,0,0,1,76-70.934c15.2-7.093,37.494-9.12,46.614,5.067,5.067,7.093,4.053,17.227,3.04,26.347-15.2,125.654-94.241,252.322-49.654,370.882,8.107,21.28,19.254,43.574,11.147,64.854-9.12,23.307-41.547,38.507-34.454,62.827,9.12,27.36,58.774,16.214,71.947,42.56C711.731,1150.244,632.691,1171.524,637.757,1211.045Z",
    transform: "translate(-37.128 -29.279)",
    fill: "#ffe149"
  })))))));
};
export default __webpack_public_path__ + "static/media/Icons_Type_02_Innovation_Selected.39f0de70.svg";
export { SvgComponent as ReactComponent };